var render = function () {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { key: _vm.renderCount, attrs: { id: "archive" } },
    [
      _c(
        "AppBreadCrumb",
        {
          attrs: {
            paths: [{ title: _vm.$t("message.archive") }],
            select: true,
            "show-subjects": true,
          },
        },
        [
          _c(
            "div",
            { staticStyle: { display: "flex", "align-items": "center" } },
            [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.timeSelect,
                      expression: "timeSelect",
                    },
                  ],
                  attrs: { id: "time-select" },
                  on: {
                    change: [
                      function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.timeSelect = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                      function ($event) {
                        return _vm.setCustomDateFilter(_vm.timeSelect)
                      },
                    ],
                  },
                },
                [
                  _c("option", { attrs: { value: "today" } }, [
                    _vm._v(_vm._s(_vm.$t("time.today"))),
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "yesterday" } }, [
                    _vm._v(_vm._s(_vm.$t("time.yesterday"))),
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "current-week" } }, [
                    _vm._v(_vm._s(_vm.$t("time.currentWeek"))),
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "last-week" } }, [
                    _vm._v(_vm._s(_vm.$t("time.lastWeek"))),
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "current-month" } }, [
                    _vm._v(_vm._s(_vm.$t("time.currentMonth"))),
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "last-month" } }, [
                    _vm._v(_vm._s(_vm.$t("time.lastMonth"))),
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "last-30" } }, [
                    _vm._v(_vm._s(_vm.$t("time.last30Day"))),
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "custom" } }, [
                    _vm._v(_vm._s(_vm.$t("time.custom"))),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.getLast11Months(), function (m, i) {
                    return _c(
                      "option",
                      { key: i, domProps: { value: m.name } },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(m.name) +
                            "\n                "
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "a-button-group",
                { key: _vm.$i18n.locale, staticClass: "ml-3" },
                [
                  _c(
                    "a-button",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                          },
                          expression:
                            "{ followCursor: true, placement: 'bottom-end' }",
                        },
                      ],
                      attrs: {
                        type: _vm.filterDescription ? "primary" : "default",
                        content: _vm.$t("message.showFeedbackHistory"),
                      },
                      on: {
                        click: function ($event) {
                          _vm.filterDescription = !_vm.filterDescription
                        },
                      },
                    },
                    [
                      _c(
                        "md-icon",
                        {
                          class: {
                            "text-dark": !_vm.filterDescription,
                            "text-light": _vm.filterDescription,
                          },
                        },
                        [_vm._v("comment\n                    ")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                          },
                          expression:
                            "{ followCursor: true, placement: 'bottom-end' }",
                        },
                      ],
                      attrs: {
                        type: _vm.filterVideoCall ? "primary" : "default",
                        content: _vm.$t("message.filterVideoCall"),
                      },
                      on: {
                        click: function ($event) {
                          _vm.filterVideoCall = !_vm.filterVideoCall
                        },
                      },
                    },
                    [
                      _c(
                        "md-icon",
                        {
                          class: {
                            "text-dark": !_vm.filterVideoCall,
                            "text-light": _vm.filterVideoCall,
                          },
                        },
                        [_vm._v("videocam\n                    ")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                          },
                          expression:
                            "{ followCursor: true, placement: 'bottom-end' }",
                        },
                      ],
                      attrs: {
                        type: _vm.filterLostChats ? "primary" : "default",
                        content: _vm.$t("message.filterLostChat"),
                      },
                      on: {
                        click: function ($event) {
                          _vm.filterLostChats = !_vm.filterLostChats
                        },
                      },
                    },
                    [
                      _c(
                        "md-icon",
                        {
                          class: {
                            "text-dark": !_vm.filterLostChats,
                            "text-light": _vm.filterLostChats,
                          },
                        },
                        [_vm._v("phone_missed\n                    ")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                          },
                          expression:
                            "{ followCursor: true, placement: 'bottom-end' }",
                        },
                      ],
                      attrs: {
                        type: _vm.filterClosedByAgent ? "primary" : "default",
                        content: _vm.$t("message.filterClosedByAgent"),
                      },
                      on: {
                        click: function ($event) {
                          _vm.filterClosedByAgent = !_vm.filterClosedByAgent
                        },
                      },
                    },
                    [
                      _c(
                        "md-icon",
                        {
                          class: {
                            "text-dark": !_vm.filterClosedByAgent,
                            "text-light": _vm.filterClosedByAgent,
                          },
                        },
                        [_vm._v("support_agent\n                    ")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                          },
                          expression:
                            "{ followCursor: true, placement: 'bottom-end' }",
                        },
                      ],
                      attrs: {
                        type: _vm.filterChatBot ? "primary" : "default",
                        content: _vm.$t("message.chatBot"),
                      },
                      on: {
                        click: function ($event) {
                          _vm.filterChatBot = !_vm.filterChatBot
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          class: {
                            "text-dark": !_vm.filterChatBot,
                            "text-light": _vm.filterChatBot,
                          },
                        },
                        [
                          _c("Chatbot", {
                            staticClass:
                              "archive-filter-icons archive-cb-icons",
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "b-container",
        { staticClass: "mt-3", attrs: { fluid: "" } },
        [
          _c(
            "b-row",
            { staticClass: "custom-row" },
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "custom-input mb-0",
                      attrs: {
                        id: "start-date-input-group",
                        label: _vm.$t("message.first"),
                        "label-for": "start-date-input",
                        "label-sr-only": "",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "display-flex" },
                        [
                          _c("a-button", {
                            staticClass: "ant-btn-background-ghost",
                            attrs: { icon: "left" },
                            on: { click: _vm.decreaseDate },
                          }),
                          _vm._v(" "),
                          _c("datetime", {
                            attrs: {
                              "max-datetime": _vm.maxDate,
                              "min-datetime": _vm.lastFiveYear,
                              phrases: _vm.phrases,
                              placeholder: _vm.$t("message.startDate"),
                              auto: "",
                              "input-class": "form-control rounded-0",
                              "input-id": "start-date-input",
                              type: "datetime",
                            },
                            model: {
                              value: _vm.startDate,
                              callback: function ($$v) {
                                _vm.startDate = $$v
                              },
                              expression: "startDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "pl-2" },
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "custom-input mb-0",
                      attrs: {
                        id: "end-date-input-group",
                        label: _vm.$t("message.last"),
                        "label-for": "end-date-input",
                        "label-sr-only": "",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "display-flex" },
                        [
                          _c("datetime", {
                            attrs: {
                              "max-datetime": _vm.maxDate,
                              "min-datetime": _vm.startDate,
                              phrases: _vm.phrases,
                              placeholder: _vm.$t("message.endDate"),
                              auto: "",
                              "input-class": "form-control rounded-0",
                              "input-id": "end-date-input",
                              type: "datetime",
                            },
                            model: {
                              value: _vm.endDate,
                              callback: function ($$v) {
                                _vm.endDate = $$v
                              },
                              expression: "endDate",
                            },
                          }),
                          _vm._v(" "),
                          _c("a-button", {
                            staticClass: "ant-btn-background-ghost",
                            attrs: { icon: "right" },
                            on: { click: _vm.incrementDate },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "pl-2" },
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "custom-input mb-0",
                      attrs: {
                        id: "query-input-group",
                        label: _vm.$t("message.query"),
                        "label-for": "query-input",
                        "label-sr-only": "",
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "query-input",
                          placeholder: _vm.$t("message.query"),
                          name: "query",
                        },
                        model: {
                          value: _vm.query,
                          callback: function ($$v) {
                            _vm.query = $$v
                          },
                          expression: "query",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "pl-2" },
                [
                  _c(
                    "b-form-group",
                    { staticClass: "custom-input mb-1" },
                    [
                      _c("multiselect", {
                        staticClass: "archive-platform-multiselect",
                        attrs: {
                          multiple: true,
                          options: _vm.multiSelectOptions,
                          placeholder: _vm.$t("message.allPlatforms"),
                          label: "name",
                          "track-by": "name",
                          "select-label": "",
                          "deselect-label": "X",
                          "selected-label": "",
                        },
                        on: { select: _vm.valueIds },
                        scopedSlots: _vm._u([
                          {
                            key: "option",
                            fn: function (props) {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "justify-content": "start",
                                      "align-items": "center",
                                    },
                                  },
                                  [
                                    props.option.name === "Whatsapp"
                                      ? _c(
                                          "div",
                                          [
                                            _c("WhatsappIcon", {
                                              staticClass: "option-icons",
                                              attrs: { color: "#25D366" },
                                            }),
                                          ],
                                          1
                                        )
                                      : props.option.name === "Instagram"
                                      ? _c(
                                          "div",
                                          [
                                            _c("InstagramIcon", {
                                              staticClass: "option-icons",
                                              attrs: {
                                                "special-background-mode": "",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : props.option.name === "Telegram"
                                      ? _c(
                                          "div",
                                          [
                                            _c("TelegramIcon", {
                                              staticClass: "option-icons",
                                            }),
                                          ],
                                          1
                                        )
                                      : props.option.name === "Supsis"
                                      ? _c(
                                          "div",
                                          [
                                            _c("SupsisIcon", {
                                              staticClass: "option-icons",
                                            }),
                                          ],
                                          1
                                        )
                                      : props.option.name === "Messenger"
                                      ? _c(
                                          "div",
                                          [
                                            _c("MessengerIcon", {
                                              staticClass: "option-icons",
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "option__desc" }, [
                                      _c(
                                        "span",
                                        { staticClass: "option__title" },
                                        [_vm._v(_vm._s(props.option.name))]
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                        model: {
                          value: _vm.multiSelectValue,
                          callback: function ($$v) {
                            _vm.multiSelectValue = $$v
                          },
                          expression: "multiSelectValue",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("br"),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "pl-2" },
                [
                  _c(
                    "b-form-group",
                    { staticClass: "custom-input mb-1" },
                    [
                      _c("multiselect", {
                        attrs: {
                          multiple: true,
                          options: _vm.destroyerMultiSelectOptions,
                          placeholder: "DestroyedBy",
                          label: "name",
                          "track-by": "name",
                          "select-label": "",
                          "deselect-label": "X",
                          "selected-label": "",
                        },
                        on: { select: _vm.selectDestroyer },
                        model: {
                          value: _vm.destroyerMultiSelectValue,
                          callback: function ($$v) {
                            _vm.destroyerMultiSelectValue = $$v
                          },
                          expression: "destroyerMultiSelectValue",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("br"),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "pl-2" },
                [
                  _c(
                    "b-form-group",
                    { staticClass: "custom-input mb-1" },
                    [
                      _c("multiselect", {
                        attrs: {
                          multiple: true,
                          options: _vm.allTags,
                          placeholder: _vm.$t("message.tags"),
                          label: "name",
                          "track-by": "name",
                          "select-label": "",
                        },
                        on: { select: _vm.selectTags },
                        scopedSlots: _vm._u([
                          {
                            key: "singleLabel",
                            fn: function (props) {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "justify-content": "start",
                                      "align-items": "center",
                                    },
                                  },
                                  [
                                    _c("div", {
                                      staticStyle: {
                                        width: "10px",
                                        height: "10px",
                                        "border-radius": "100%",
                                        "margin-right": "5px",
                                      },
                                      style: { background: props.option.color },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "option__title" },
                                      [_vm._v(_vm._s(props.option.title))]
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "option",
                            fn: function (props) {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "justify-content": "start",
                                      "align-items": "center",
                                    },
                                  },
                                  [
                                    _c("div", {
                                      staticStyle: {
                                        width: "10px",
                                        height: "10px",
                                        "border-radius": "100%",
                                        "margin-right": "5px",
                                      },
                                      style: { background: props.option.color },
                                    }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "option__desc" }, [
                                      _c(
                                        "span",
                                        { staticClass: "option__title" },
                                        [_vm._v(_vm._s(props.option.name))]
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                        model: {
                          value: _vm.tagsMultiSelectValue,
                          callback: function ($$v) {
                            _vm.tagsMultiSelectValue = $$v
                          },
                          expression: "tagsMultiSelectValue",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("br"),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "1" } },
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "mb-1 custom-input",
                      attrs: { id: "query-input-group3" },
                    },
                    [
                      _c(
                        "b-form-select",
                        {
                          staticClass: "mb-3",
                          model: {
                            value: _vm.selectedSite,
                            callback: function ($$v) {
                              _vm.selectedSite = $$v
                            },
                            expression: "selectedSite",
                          },
                        },
                        [
                          _c("option", { domProps: { value: null } }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t("message.allSites")) +
                                "\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.customerDomains, function (site) {
                            return _c(
                              "option",
                              { key: site, domProps: { value: site } },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(site) +
                                    "\n                        "
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "pl-2" },
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "custom-input mb-0",
                      attrs: {
                        id: "query-input-group2",
                        label: "Sorgu",
                        "label-for": "query-input",
                        "label-sr-only": "",
                      },
                    },
                    [
                      _c(
                        "b-form-select",
                        {
                          staticClass: "mb-3",
                          model: {
                            value: _vm.selectedUser,
                            callback: function ($$v) {
                              _vm.selectedUser = $$v
                            },
                            expression: "selectedUser",
                          },
                        },
                        [
                          _c("option", { domProps: { value: null } }, [
                            _vm._v(_vm._s(_vm.$t("message.all"))),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "reps" } }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t("message.onlyAgents")) +
                                "\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "chatBot" } }, [
                            _vm._v(_vm._s(_vm.$t("message.onlyChatbot"))),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.usersFilter.data, function (item) {
                            return _c(
                              "option",
                              { key: item._id, domProps: { value: item._id } },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(item.name) +
                                    "\n                        "
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("b-col", { staticClass: "pl-2" }, [
                _c("div", { staticClass: "custom-input" }, [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "align-items": "center" },
                    },
                    [
                      _c("a-rate", {
                        attrs: { "allow-clear": true },
                        model: {
                          value: _vm.point,
                          callback: function ($$v) {
                            _vm.point = $$v
                          },
                          expression: "point",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: {
                                followCursor: true,
                                placement: "bottom",
                              },
                              expression:
                                "{ followCursor: true, placement: 'bottom' }",
                            },
                          ],
                          staticClass: "question-button",
                          attrs: { content: _vm.$t("message.archiveAllRated") },
                          on: {
                            click: function ($event) {
                              _vm.point = -1
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                            ?\n                        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ],
            1
          ),
          _vm._v("\n        " + _vm._s(_vm.selectedVisitorId) + "\n        "),
          _vm.selectedVisitorId
            ? _c(
                "b-row",
                { staticClass: "filterLabelWrapper" },
                [
                  _c("VisitorMiniFilterPreview", {
                    attrs: {
                      "default-open": false,
                      value: {
                        name: "visitorId",
                        value: _vm.selectedVisitorId,
                        rule: "is",
                      },
                      "on-finished": _vm.$_.noop,
                      "on-removed": _vm.removeSelectedVisitorIDFilter,
                      icon: "filter_alt",
                      "read-only": true,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "custom-row" },
            [
              _c(
                "b-col",
                {
                  class: {
                    "col-lg-5": !_vm.wideScreen,
                    "col-lg-4": _vm.wideScreen,
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "scrollable",
                      attrs: { "scroll-top": "0", id: "conversation-list" },
                    },
                    [
                      _c("div", [
                        _c(
                          "div",
                          { staticClass: "pagination-toolbar" },
                          [
                            _c(
                              "a-button",
                              {
                                directives: [
                                  {
                                    name: "tippy",
                                    rawName: "v-tippy",
                                    value: {
                                      content:
                                        "Sayfada seçili olan filtre değerlerini temizler",
                                    },
                                    expression:
                                      "{ content: 'Sayfada seçili olan filtre değerlerini temizler' }",
                                  },
                                ],
                                staticClass:
                                  "actionButton d-flex align-items-center classic-button",
                                staticStyle: {
                                  "margin-right": "auto !important",
                                },
                                attrs: { size: "small" },
                                on: { click: _vm.resetFilters },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "margin-right": "3px",
                                      display: "block",
                                      "font-size": "12px",
                                    },
                                  },
                                  [
                                    _c("span", { staticClass: "md-icon" }, [
                                      _vm._v("delete_forever"),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "actions" },
                              [
                                _c(
                                  "a",
                                  {
                                    staticStyle: { "margin-right": "10px" },
                                    on: { click: _vm.decreaseAll },
                                  },
                                  [_vm._v("<<")]
                                ),
                                _vm._v(" "),
                                _c("a", { on: { click: _vm.decrease } }, [
                                  _vm._v("<"),
                                ]),
                                _vm._v(" "),
                                _c("a-input", {
                                  staticStyle: {
                                    width: "60px",
                                    border: "none",
                                  },
                                  attrs: { type: "number" },
                                  model: {
                                    value: _vm.currentPage,
                                    callback: function ($$v) {
                                      _vm.currentPage = $$v
                                    },
                                    expression: "currentPage",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      padding: "2px",
                                      "font-size": "15px",
                                    },
                                  },
                                  [_vm._v("/")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      width: "auto",
                                      margin: "0 6px",
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.visitors.pageCount))]
                                ),
                                _vm._v(" "),
                                _c("a", { on: { click: _vm.increase } }, [
                                  _vm._v(">"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticStyle: { "margin-left": "10px" },
                                    on: { click: _vm.increaseAll },
                                  },
                                  [_vm._v(">>")]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "a-popover",
                              {
                                attrs: {
                                  placement: "bottom",
                                  overlayClassName: "btnPerPagePopover",
                                  visible: _vm.pageSizeChangerVisible,
                                },
                                on: {
                                  visibleChange: function ($event) {
                                    _vm.pageSizeChangerVisible =
                                      !_vm.pageSizeChangerVisible
                                  },
                                },
                              },
                              [
                                _c("template", { slot: "content" }, [
                                  _c(
                                    "div",
                                    { staticClass: "page-options" },
                                    _vm._l(
                                      [
                                        5, 10, 20, 30, 50, 75, 100, 150, 200,
                                        250, 300,
                                      ],
                                      function (val, i) {
                                        return _c(
                                          "div",
                                          {
                                            key: i,
                                            staticClass: "item",
                                            on: {
                                              click: function ($event) {
                                                return _vm.changePerPage(val)
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "value" },
                                              [_vm._v(_vm._s(val))]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "a-button",
                                  {
                                    staticClass: "btnPerPage",
                                    on: {
                                      click: function ($event) {
                                        _vm.pageSizeChangerVisible = true
                                      },
                                    },
                                  },
                                  [
                                    _c("SortIcon"),
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.$t("message.perPageInFilter")
                                        ) +
                                        ": " +
                                        _vm._s(_vm.pagination.limit) +
                                        "\n                                    "
                                    ),
                                    _c("a-icon", {
                                      attrs: { type: "caret-down" },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      !_vm.isBusy && !_vm.spinnerShow
                        ? _c("div", [
                            !!_vm.selectedHistory.messages.length
                              ? _c(
                                  "div",
                                  [
                                    !_vm.isScrolling
                                      ? _c(
                                          "b-table",
                                          {
                                            attrs: {
                                              id: "visitor-list-table",
                                              items: _vm.visitors.data.slice(
                                                0,
                                                _vm.perPage
                                              ),
                                              fields: _vm.fields,
                                              "tbody-tr-class": _vm.rowClass,
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "cell(actions)",
                                                  fn: function (data, item) {
                                                    return [
                                                      _c(
                                                        "div",
                                                        {
                                                          key: data.item._id,
                                                          staticClass: "info",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.view(
                                                                data.item._id
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "custom-card userInfo",
                                                            },
                                                            [
                                                              _c("b", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    data.item
                                                                      .fullname ||
                                                                      "-"
                                                                  )
                                                                ),
                                                              ]),
                                                              _vm._v(" "),
                                                              _c("b", [
                                                                _vm._v(
                                                                  "\n                                                " +
                                                                    _vm._s(
                                                                      _vm.getEmail(
                                                                        data.item
                                                                      )
                                                                    ) +
                                                                    "\n                                            "
                                                                ),
                                                              ]),
                                                              _vm._v(" "),
                                                              _c("b", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    (data.item
                                                                      .users
                                                                      .length >
                                                                    0
                                                                      ? data.item.users.slice(
                                                                          0,
                                                                          3
                                                                        )
                                                                      : [
                                                                          data
                                                                            .item
                                                                            .connectedUser,
                                                                        ]
                                                                    )
                                                                      .map(
                                                                        function (
                                                                          x
                                                                        ) {
                                                                          return _vm.getUserHelper(
                                                                            x
                                                                          )
                                                                        }
                                                                      )
                                                                      .join(
                                                                        ", "
                                                                      )
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "custom-card back chatMeta",
                                                            },
                                                            [
                                                              _c("b", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "date"
                                                                    )(
                                                                      data.item
                                                                        .createdDate,
                                                                      "D/M/YY HH:m:s"
                                                                    )
                                                                  )
                                                                ),
                                                              ]),
                                                              _vm._v(" "),
                                                              _c(
                                                                "b",
                                                                [
                                                                  _c(
                                                                    "PassedTimeCounterTimeFormat",
                                                                    {
                                                                      attrs: {
                                                                        id: data
                                                                          .item
                                                                          ._id,
                                                                        date:
                                                                          data
                                                                            .item
                                                                            .connectedDate ||
                                                                          data
                                                                            .item
                                                                            .createdDate,
                                                                        endDate:
                                                                          data
                                                                            .item
                                                                            .destroyedDate,
                                                                        shortFormat: true,
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "b",
                                                                [
                                                                  _c("a-rate", {
                                                                    style: {
                                                                      color:
                                                                        data
                                                                          .item
                                                                          .description
                                                                          ? "orangered"
                                                                          : "#fadb14",
                                                                    },
                                                                    attrs: {
                                                                      "default-value":
                                                                        data
                                                                          .item
                                                                          .point ||
                                                                        0,
                                                                      disabled:
                                                                        "",
                                                                      size: "12",
                                                                    },
                                                                  }),
                                                                ],
                                                                1
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              2416333239
                                            ),
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-center text-danger my-2",
                                                attrs: { slot: "table-busy" },
                                                slot: "table-busy",
                                              },
                                              [
                                                _c("b-spinner", {
                                                  staticClass: "align-middle",
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text-center text-info my-3",
                                          },
                                          [
                                            _c(
                                              "b-table",
                                              {
                                                attrs: {
                                                  id: "visitor-list-tables",
                                                  fields: _vm.fields,
                                                  items: _vm.visitors.data,
                                                  "tbody-tr-class":
                                                    _vm.rowClass,
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "cell(actions)",
                                                      fn: function (
                                                        data,
                                                        item
                                                      ) {
                                                        return [
                                                          _c(
                                                            "div",
                                                            {
                                                              key: data.item
                                                                ._id,
                                                              staticClass:
                                                                "info",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.view(
                                                                      data.item
                                                                        ._id
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "custom-card userInfo",
                                                                },
                                                                [
                                                                  _c("b", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        data
                                                                          .item
                                                                          .fullname ||
                                                                          "-"
                                                                      )
                                                                    ),
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c("b", [
                                                                    _vm._v(
                                                                      "\n                                                    " +
                                                                        _vm._s(
                                                                          _vm.getEmail(
                                                                            data.item
                                                                          )
                                                                        ) +
                                                                        "\n                                                "
                                                                    ),
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c("b", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        (data
                                                                          .item
                                                                          .users
                                                                          .length >
                                                                        0
                                                                          ? data.item.users.slice(
                                                                              0,
                                                                              3
                                                                            )
                                                                          : [
                                                                              data
                                                                                .item
                                                                                .connectedUser,
                                                                            ]
                                                                        )
                                                                          .map(
                                                                            function (
                                                                              x
                                                                            ) {
                                                                              return _vm.getUserHelper(
                                                                                x
                                                                              )
                                                                            }
                                                                          )
                                                                          .join(
                                                                            ", "
                                                                          )
                                                                      )
                                                                    ),
                                                                  ]),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "custom-card back chatMeta",
                                                                },
                                                                [
                                                                  _c("b", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm._f(
                                                                          "date"
                                                                        )(
                                                                          data
                                                                            .item
                                                                            .createdDate,
                                                                          "D/M/YY HH:m:s"
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "b",
                                                                    [
                                                                      _c(
                                                                        "PassedTimeCounterTimeFormat",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              id: data
                                                                                .item
                                                                                ._id,
                                                                              date:
                                                                                data
                                                                                  .item
                                                                                  .connectedDate ||
                                                                                data
                                                                                  .item
                                                                                  .createdDate,
                                                                              endDate:
                                                                                data
                                                                                  .item
                                                                                  .destroyedDate,
                                                                              shortFormat: true,
                                                                            },
                                                                        }
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "b",
                                                                    [
                                                                      _c(
                                                                        "a-rate",
                                                                        {
                                                                          style:
                                                                            {
                                                                              color:
                                                                                data
                                                                                  .item
                                                                                  .description
                                                                                  ? "orangered"
                                                                                  : "#fadb14",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "default-value":
                                                                                data
                                                                                  .item
                                                                                  .point ||
                                                                                0,
                                                                              disabled:
                                                                                "",
                                                                              size: "12",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  false,
                                                  3508913591
                                                ),
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-center text-danger my-2",
                                                    attrs: {
                                                      slot: "table-busy",
                                                    },
                                                    slot: "table-busy",
                                                  },
                                                  [
                                                    _c("b-spinner", {
                                                      staticClass:
                                                        "align-middle",
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "ul",
                                              {
                                                staticClass: "archive-skeleton",
                                              },
                                              _vm._l(3, function (v, i) {
                                                return _c(
                                                  "li",
                                                  {
                                                    key: i,
                                                    staticClass: "pb-3",
                                                    staticStyle: {
                                                      "list-style": "none",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "info row",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col custom-card userInfo",
                                                          },
                                                          [
                                                            _c("a-skeleton", {
                                                              attrs: {
                                                                active: "",
                                                                paragraph: {
                                                                  rows: 2,
                                                                },
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col custom-card back chatMeta",
                                                          },
                                                          [
                                                            _c("a-skeleton", {
                                                              staticClass:
                                                                "row",
                                                              staticStyle: {
                                                                "padding-left":
                                                                  "15px",
                                                              },
                                                              attrs: {
                                                                active: "",
                                                                paragraph: {
                                                                  rows: 1,
                                                                },
                                                              },
                                                            }),
                                                            _vm._v(" "),
                                                            _c(
                                                              "b",
                                                              {
                                                                staticStyle: {
                                                                  display:
                                                                    "block",
                                                                  "text-align":
                                                                    "start",
                                                                  "margin-top":
                                                                    "13px",
                                                                },
                                                              },
                                                              [
                                                                _c("a-rate", {
                                                                  staticClass:
                                                                    "row",
                                                                  staticStyle: {
                                                                    color:
                                                                      "#fadb14",
                                                                  },
                                                                  attrs: {
                                                                    "default-value": 5,
                                                                    disabled:
                                                                      "",
                                                                    size: "12",
                                                                  },
                                                                }),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              }),
                                              0
                                            ),
                                          ],
                                          1
                                        ),
                                  ],
                                  1
                                )
                              : _c(
                                  "div",
                                  { staticClass: "text-center text-info my-3" },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_vm.$t("message.chatNotFound")) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !!_vm.isBusy && !_vm.spinnerShow
                        ? _c(
                            "div",
                            { staticClass: "text-center text-info my-3" },
                            [
                              !!_vm.lastRegisteredMessages.length
                                ? _c(
                                    "div",
                                    [
                                      !_vm.isScrolling
                                        ? _c(
                                            "b-table",
                                            {
                                              attrs: {
                                                id: "visitor-list-table",
                                                fields: _vm.fields,
                                                items:
                                                  _vm.lastRegisteredMessages,
                                                "tbody-tr-class": _vm.rowClass,
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "cell(actions)",
                                                    fn: function (data, item) {
                                                      return [
                                                        _c(
                                                          "div",
                                                          {
                                                            key: data.item._id,
                                                            staticClass: "info",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.view(
                                                                  data.item._id
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "custom-card userInfo",
                                                              },
                                                              [
                                                                _c("b", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      data.item
                                                                        .fullname ||
                                                                        "-"
                                                                    )
                                                                  ),
                                                                ]),
                                                                _vm._v(" "),
                                                                _c("b", [
                                                                  _vm._v(
                                                                    "\n                                                " +
                                                                      _vm._s(
                                                                        _vm.getEmail(
                                                                          data.item
                                                                        )
                                                                      ) +
                                                                      "\n                                            "
                                                                  ),
                                                                ]),
                                                                _vm._v(" "),
                                                                _c("b", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      (data.item
                                                                        .users
                                                                        .length >
                                                                      0
                                                                        ? data.item.users.slice(
                                                                            0,
                                                                            3
                                                                          )
                                                                        : [
                                                                            data
                                                                              .item
                                                                              .connectedUser,
                                                                          ]
                                                                      )
                                                                        .map(
                                                                          function (
                                                                            x
                                                                          ) {
                                                                            return _vm.getUserHelper(
                                                                              x
                                                                            )
                                                                          }
                                                                        )
                                                                        .join(
                                                                          ", "
                                                                        )
                                                                    )
                                                                  ),
                                                                ]),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "custom-card back chatMeta",
                                                              },
                                                              [
                                                                _c("b", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "date"
                                                                      )(
                                                                        data
                                                                          .item
                                                                          .createdDate,
                                                                        "D/M/YY HH:m:s"
                                                                      )
                                                                    )
                                                                  ),
                                                                ]),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "b",
                                                                  [
                                                                    _c(
                                                                      "PassedTimeCounterTimeFormat",
                                                                      {
                                                                        attrs: {
                                                                          id: data
                                                                            .item
                                                                            ._id,
                                                                          date:
                                                                            data
                                                                              .item
                                                                              .connectedDate ||
                                                                            data
                                                                              .item
                                                                              .createdDate,
                                                                          endDate:
                                                                            data
                                                                              .item
                                                                              .destroyedDate,
                                                                          shortFormat: true,
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "b",
                                                                  [
                                                                    _c(
                                                                      "a-rate",
                                                                      {
                                                                        style: {
                                                                          color:
                                                                            data
                                                                              .item
                                                                              .description
                                                                              ? "orangered"
                                                                              : "#fadb14",
                                                                        },
                                                                        attrs: {
                                                                          "default-value":
                                                                            data
                                                                              .item
                                                                              .point ||
                                                                            0,
                                                                          disabled:
                                                                            "",
                                                                          size: "12",
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                2416333239
                                              ),
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "text-center text-danger my-2",
                                                  attrs: { slot: "table-busy" },
                                                  slot: "table-busy",
                                                },
                                                [
                                                  _c("b-spinner", {
                                                    staticClass: "align-middle",
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "ul",
                                { staticClass: "archive-skeleton" },
                                _vm._l(_vm.skeletonCount, function (v, i) {
                                  return _c(
                                    "li",
                                    {
                                      key: i,
                                      staticClass: "pb-3",
                                      staticStyle: { "list-style": "none" },
                                    },
                                    [
                                      _c("div", { staticClass: "info row" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col custom-card userInfo",
                                          },
                                          [
                                            _c("a-skeleton", {
                                              attrs: {
                                                active: "",
                                                paragraph: { rows: 2 },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col custom-card back chatMeta",
                                          },
                                          [
                                            _c("a-skeleton", {
                                              staticClass: "row",
                                              staticStyle: {
                                                "padding-left": "15px",
                                              },
                                              attrs: {
                                                active: "",
                                                paragraph: { rows: 1 },
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "b",
                                              {
                                                staticStyle: {
                                                  display: "block",
                                                  "text-align": "start",
                                                  "margin-top": "13px",
                                                },
                                              },
                                              [
                                                _c("a-rate", {
                                                  staticClass: "row",
                                                  staticStyle: {
                                                    color: "#fadb14",
                                                  },
                                                  attrs: {
                                                    "default-value": 5,
                                                    disabled: "",
                                                    size: "12",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.spinnerShow
                        ? [
                            _c("font-awesome-icon", {
                              attrs: { icon: "spinner", spin: "" },
                            }),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "pl-3",
                  class: {
                    "col-lg-7": !_vm.wideScreen,
                    "col-lg-5": _vm.wideScreen,
                  },
                },
                [
                  _c("div", { staticClass: "scrollable" }, [
                    _vm.selectedHistory.id && !_vm.wideScreen
                      ? _c(
                          "div",
                          { staticClass: "userMetaInfo bg-white" },
                          [
                            _c("b-col", { staticStyle: { margin: "10px" } }, [
                              _c("div", { staticClass: "userInfo" }, [
                                _c("div", { staticClass: "userInfo first" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(_vm.$t("message.fullName")) +
                                      "\n                                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "tippy",
                                        rawName: "v-tippy",
                                        value: {
                                          followCursor: true,
                                          placement: "bottom-end",
                                          theme: _vm.isDarkMode
                                            ? "light-border"
                                            : "google",
                                        },
                                        expression:
                                          "{\n                                        followCursor: true,\n                                        placement: 'bottom-end',\n                                        theme: isDarkMode ? 'light-border' : 'google',\n                                    }",
                                      },
                                    ],
                                    staticClass: "userInfo sec",
                                    attrs: {
                                      content:
                                        _vm.selectedHistory.conversation
                                          .fullname,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.selectedHistory.conversation
                                            .fullname
                                        ) +
                                        "\n                                "
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "userInfo" }, [
                                _c("div", { staticClass: "userInfo first" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(_vm.$t("message.email")) +
                                      "\n                                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "tippy",
                                        rawName: "v-tippy",
                                        value: {
                                          followCursor: true,
                                          placement: "bottom-end",
                                          theme: _vm.isDarkMode
                                            ? "light-border"
                                            : "google",
                                        },
                                        expression:
                                          "{\n                                        followCursor: true,\n                                        placement: 'bottom-end',\n                                        theme: isDarkMode ? 'light-border' : 'google',\n                                    }",
                                      },
                                    ],
                                    staticClass: "userInfo sec",
                                    attrs: {
                                      content:
                                        _vm.selectedHistory.conversation.email,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.selectedHistory.conversation.email
                                        ) +
                                        "\n                                "
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "userInfo" }, [
                                _c("div", { staticClass: "userInfo first" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(_vm.$t("message.department")) +
                                      "\n                                "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "userInfo" }, [
                                _c("div", { staticClass: "userInfo first" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(_vm.$t("message.representative")) +
                                      "\n                                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "userInfo sec" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        (_vm.selectedHistory.conversation.users
                                          .length > 0
                                          ? _vm.selectedHistory.conversation.users.slice(
                                              0,
                                              3
                                            )
                                          : [
                                              _vm.selectedHistory.conversation
                                                .connectedUser,
                                            ]
                                        )
                                          .map(function (x) {
                                            return _vm.getUserHelper(x)
                                          })
                                          .join(", ")
                                      ) +
                                      "\n                                "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "d-flex" }, [
                                _c("div", { staticClass: "userInfo" }, [
                                  _c("div", { staticClass: "userInfo first" }, [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(_vm.$t("message.country")) +
                                        "\n                                    "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "userInfo sec" }, [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(
                                          _vm.$_.get(
                                            _vm.selectedHistory,
                                            "conversation.visitor.country",
                                            "-"
                                          )
                                        ) +
                                        "\n                                    "
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "userInfo pl-3" }, [
                                  _c("div", { staticClass: "userInfo first" }, [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(_vm.$t("message.language")) +
                                        "\n                                    "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "userInfo sec" }, [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(
                                          _vm.selectedHistory.conversation
                                            .languageCode
                                        ) +
                                        "\n                                    "
                                    ),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "userInfo" }, [
                                _c("div", { staticClass: "userInfo first" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(_vm.$t("message.osAndBrowser")) +
                                      "\n                                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "userInfo sec" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm.$_.get(
                                          _vm.selectedHistory,
                                          "conversation.visitor.os"
                                        )
                                      ) +
                                      "\n                                    " +
                                      _vm._s(
                                        _vm.$_.get(
                                          _vm.selectedHistory,
                                          "conversation.visitor.browser"
                                        )
                                      ) +
                                      "\n                                "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "userInfo" }, [
                                _c("div", { staticClass: "userInfo first" }, [
                                  _vm._v("IP"),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "userInfo sec" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm.$_.get(
                                          _vm.selectedHistory,
                                          "conversation.visitor.ipAddress"
                                        )
                                      ) +
                                      "\n                                "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "userInfo" }, [
                                _c("div", { staticClass: "userInfo first" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(_vm.$t("message.chatId")) +
                                      "\n                                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "userInfo sec" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm.selectedHistory.conversation._id
                                      ) +
                                      "\n                                "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "userInfo" }, [
                                _c("div", { staticClass: "userInfo first" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(_vm.$t("message.visitorId")) +
                                      "\n                                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "userInfo sec" },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.$_.get(
                                            _vm.selectedHistory,
                                            "conversation.visitor._id"
                                          )
                                        ) +
                                        "\n                                    "
                                    ),
                                    _vm.selectedHistory.conversation
                                      .startedWithChatBot
                                      ? _c(
                                          "md-button",
                                          {
                                            directives: [
                                              {
                                                name: "tippy",
                                                rawName: "v-tippy",
                                                value: {
                                                  followCursor: true,
                                                  placement: "bottom-end",
                                                  theme: _vm.isDarkMode
                                                    ? "light-border"
                                                    : "google",
                                                },
                                                expression:
                                                  "{\n                                            followCursor: true,\n                                            placement: 'bottom-end',\n                                            theme: isDarkMode ? 'light-border' : 'google',\n                                        }",
                                              },
                                            ],
                                            staticClass: "md-icon-button",
                                            attrs: {
                                              content: "Open In Chatbot",
                                            },
                                            on: { click: _vm.openInChatbot },
                                          },
                                          [
                                            _c("md-icon", [
                                              _vm._v("open_in_new"),
                                            ]),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "userInfo" }, [
                                _c("div", { staticClass: "userInfo first" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm.$t("message.customerClientVersion")
                                      ) +
                                      "\n                                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "userInfo sec" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm.$_.get(
                                          _vm.selectedHistory,
                                          "conversation.visitor.version.versionStr",
                                          "-"
                                        )
                                      ) +
                                      "\n                                "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _vm.selectedHistory.conversation.description
                                ? _c("div", { staticClass: "userInfo" }, [
                                    _c(
                                      "div",
                                      { staticClass: "userInfo first" },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.$t("message.visitorFeedback")
                                            ) +
                                            "\n                                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "userInfo sec",
                                        on: { click: _vm.showModal },
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            directives: [
                                              {
                                                name: "b-modal",
                                                rawName:
                                                  "v-b-modal.visitor-message",
                                                modifiers: {
                                                  "visitor-message": true,
                                                },
                                              },
                                            ],
                                            staticStyle: {
                                              "word-wrap": "break-word",
                                              overflow: "hidden",
                                              "text-overflow": "ellipsis",
                                              display: "-webkit-box",
                                              "-webkit-box-orient": "vertical",
                                              "-webkit-line-clamp": "3",
                                              "word-break": "break-all",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  _vm.selectedHistory
                                                    .conversation.description
                                                ) +
                                                "\n                                    "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              [
                                _c("b-col", [
                                  _c(
                                    "h5",
                                    {
                                      staticClass:
                                        "text-center pointer text-info my-2",
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(_vm.$t("message.userInfo")) +
                                          "\n                                    "
                                      ),
                                      _c(
                                        "md-icon",
                                        { staticClass: "text-info" },
                                        [_vm._v("expand_more")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isBusy || _vm.isLoading
                      ? _c("div", { attrs: { id: "message-skeleton" } }, [
                          _c(
                            "div",
                            {
                              staticClass: "row",
                              staticStyle: {
                                display: "flex",
                                "flex-direction": "column",
                                "align-items": "center",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "col-sm-4" },
                                [
                                  _c("a-skeleton", {
                                    attrs: {
                                      active: "",
                                      paragraph: { rows: 0 },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "row",
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "col-sm-4",
                                  staticStyle: { "margin-top": "-12%" },
                                },
                                [
                                  _c("a-skeleton", {
                                    attrs: {
                                      active: "",
                                      paragraph: { rows: 1 },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "col-sm-4",
                                  staticStyle: { "margin-top": "-8%" },
                                },
                                [
                                  _c("a-skeleton", {
                                    attrs: {
                                      active: "",
                                      paragraph: { rows: 2 },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "row",
                              staticStyle: {
                                display: "flex",
                                "flex-direction": "column",
                                "align-items": "center",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "col-sm-6",
                                  staticStyle: { "margin-top": "-15%" },
                                },
                                [
                                  _c("a-skeleton", {
                                    attrs: {
                                      active: "",
                                      paragraph: { rows: 0 },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "row",
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "col-sm-4",
                                  staticStyle: { "margin-top": "-12%" },
                                },
                                [
                                  _c("a-skeleton", {
                                    attrs: {
                                      active: "",
                                      paragraph: { rows: 2 },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "col-sm-4",
                                  staticStyle: { "margin-top": "-8%" },
                                },
                                [
                                  _c("a-skeleton", {
                                    attrs: {
                                      active: "",
                                      paragraph: { rows: 0 },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ])
                      : _c(
                          "div",
                          [
                            _vm.getMessages().length &&
                            _vm.selectedHistory.conversation._id !== null
                              ? _c("MessageList", {
                                  attrs: {
                                    "always-scroll-to-bottom": false,
                                    colors: _vm.colors,
                                    messages: _vm.getMessages(),
                                    participants: _vm.getParticipants(),
                                    "scroll-top": true,
                                    "channel-id":
                                      _vm.selectedHistory.conversation.channel,
                                    contextMenuVisable: false,
                                  },
                                })
                              : _c(
                                  "div",
                                  {
                                    staticClass:
                                      "bg-light border px-3 py-1 px-3 text-center",
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.$t("message.noMessageInChat")
                                        ) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                          ],
                          1
                        ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm.isBusy || _vm.isLoading
                ? _c("b-col", { staticClass: "col-lg-3 bg-white scrollable" }, [
                    _c(
                      "ul",
                      { staticClass: "head-title" },
                      [
                        _c("a-skeleton", {
                          attrs: { active: "", paragraph: { rows: 0 } },
                        }),
                        _vm._v(" "),
                        _vm._l(11, function (v, i) {
                          return _c(
                            "li",
                            {
                              key: i,
                              staticClass: "user-info-container mx-3 px-3",
                              staticStyle: { "list-style": "none" },
                            },
                            [
                              _c("a-skeleton", {
                                attrs: { active: "", paragraph: { rows: 0 } },
                              }),
                            ],
                            1
                          )
                        }),
                      ],
                      2
                    ),
                  ])
                : _c(
                    "b-col",
                    {
                      staticClass: "archiveUserInfoWidget",
                      class: [
                        _vm.selectedHistory.id ? "" : "bg-white scrollable",
                      ],
                      style: !_vm.selectedHistory.id && { padding: "4px" },
                      attrs: {
                        id: [_vm.selectedHistory.id ? "" : "information-list2"],
                      },
                    },
                    [
                      _vm.selectedHistory.id
                        ? _c(
                            "div",
                            [
                              _c("div", { attrs: { id: "chatCard" } }, [
                                _c("div", { staticClass: "headtitle" }, [
                                  _c("span", { staticClass: "text" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("userInfoWidget.userInformation")
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "ml-4 btn-start-chat" },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "classic-button",
                                          on: {
                                            click: function () {
                                              return this$1.$router.push(
                                                "/visitors/" +
                                                  _vm.selectedHistory
                                                    .conversation.visitor._id
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                _vm.$t("message.userProfile")
                                              ) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.isWABusiness()
                                        ? _c(
                                            "button",
                                            {
                                              staticClass: "userProfile",
                                              on: {
                                                click: _vm.startWhatsappChat,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    Start Chat\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isWhatsappV1()
                                        ? _c(
                                            "button",
                                            {
                                              staticClass: "userProfile",
                                              on: {
                                                click: _vm.startWhatsappChat,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    Start Chat\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isWhatsappV2()
                                        ? _c(
                                            "button",
                                            {
                                              staticClass: "userProfile",
                                              on: {
                                                click: _vm.startWhatsappChat,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    Start Chat\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "details-chat-card" },
                                  [
                                    _vm.getSubjectName(
                                      _vm.selectedHistory.conversation.subject
                                    )
                                      ? _c(
                                          "div",
                                          { staticClass: "user-detail" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "icon material-icons",
                                              },
                                              [_vm._v("sell")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "flex w-full centered space-between",
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(
                                                        _vm.getSubjectName(
                                                          _vm.selectedHistory
                                                            .conversation
                                                            .subject
                                                        )
                                                      ) +
                                                      "\n                                    "
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass: "copyButton",
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.copyTextToClipboard(
                                                          _vm.getSubjectName(
                                                            _vm.selectedHistory
                                                              .conversation
                                                              .subject
                                                          ) || "N/A"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("a-icon", {
                                                      attrs: { type: "copy" },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "user-detail" }, [
                                      _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "tippy",
                                              rawName: "v-tippy",
                                              value: {
                                                followCursor: true,
                                                placement: "bottom-end",
                                              },
                                              expression:
                                                "{\n                                        followCursor: true,\n                                        placement: 'bottom-end',\n                                    }",
                                            },
                                          ],
                                          staticClass: "icon material-icons",
                                          attrs: {
                                            content: _vm.$t(
                                              "userInfoWidget.fullName"
                                            ),
                                          },
                                        },
                                        [_vm._v("person")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "input-value" },
                                        [
                                          _c("div", { staticClass: "w-full" }, [
                                            _c(
                                              "span",
                                              { attrs: { id: "fullName" } },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.selectedHistory
                                                      .conversation.fullname ||
                                                      "N/A"
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "md-icon",
                                                staticStyle: {
                                                  color: "#ffa800",
                                                  cursor: "pointer",
                                                },
                                                on: { click: _vm.seeAll },
                                              },
                                              [_vm._v("zoom_in")]
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("div", [
                                            _c(
                                              "button",
                                              {
                                                staticClass: "copyButton",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.copyTextToClipboard(
                                                      _vm.selectedHistory
                                                        .conversation
                                                        .fullname || "N/A"
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("a-icon", {
                                                  attrs: { type: "copy" },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "user-detail" }, [
                                      _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "tippy",
                                              rawName: "v-tippy",
                                              value: {
                                                followCursor: true,
                                                placement: "bottom-end",
                                              },
                                              expression:
                                                "{\n                                        followCursor: true,\n                                        placement: 'bottom-end',\n                                    }",
                                            },
                                          ],
                                          staticClass: "icon material-icons",
                                          attrs: {
                                            content: _vm.$t("coupon.email"),
                                          },
                                        },
                                        [_vm._v("mail")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "input-value" },
                                        [
                                          _c("div", { staticClass: "w-full" }, [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  _vm.selectedHistory
                                                    .conversation.email || "N/A"
                                                ) +
                                                "\n                                    "
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("div", [
                                            _c(
                                              "button",
                                              {
                                                staticClass: "copyButton",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.copyTextToClipboard(
                                                      _vm.selectedHistory
                                                        .conversation.email ||
                                                        "N/A"
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("a-icon", {
                                                  attrs: { type: "copy" },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.getCustomLoginInfos(),
                                      function (inputValue) {
                                        return Array.isArray(
                                          _vm.selectedHistory.conversation
                                            .customLoginInfos
                                        ) &&
                                          _vm.selectedHistory.conversation
                                            .customLoginInfos.length
                                          ? _c(
                                              "div",
                                              {
                                                key: inputValue.name,
                                                staticClass: "user-detail",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "tippy",
                                                        rawName: "v-tippy",
                                                        value: {
                                                          followCursor: true,
                                                          placement:
                                                            "bottom-end",
                                                        },
                                                        expression:
                                                          "{\n                                        followCursor: true,\n                                        placement: 'bottom-end',\n                                    }",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "icon material-icons",
                                                    attrs: {
                                                      content: inputValue.name,
                                                    },
                                                  },
                                                  [_vm._v("alternate_email")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "input-value",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "w-full" },
                                                      [
                                                        _vm._v(
                                                          "\n                                        " +
                                                            _vm._s(
                                                              inputValue.value ||
                                                                "N/A"
                                                            ) +
                                                            "\n                                    "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("div", [
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "copyButton",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.copyTextToClipboard(
                                                                inputValue.value ||
                                                                  "N/A"
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("a-icon", {
                                                            attrs: {
                                                              type: "copy",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e()
                                      }
                                    ),
                                    _vm._v(" "),
                                    _vm._l(
                                      (
                                        (_vm.selectedHistory.conversation
                                          .visitor &&
                                          _vm.selectedHistory.conversation
                                            .visitor.contactProperties) ||
                                        []
                                      ).filter(function (x) {
                                        return x.property
                                      }),
                                      function (attr) {
                                        return _vm.selectedHistory.conversation
                                          .visitor
                                          ? _c(
                                              "div",
                                              {
                                                key: attr._id,
                                                staticClass: "user-detail",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "tippy",
                                                        rawName: "v-tippy",
                                                        value: {
                                                          followCursor: true,
                                                          placement:
                                                            "bottom-end",
                                                        },
                                                        expression:
                                                          "{\n                                        followCursor: true,\n                                        placement: 'bottom-end',\n                                    }",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "icon material-icons",
                                                    attrs: {
                                                      content:
                                                        attr.property.label,
                                                    },
                                                  },
                                                  [_vm._v("data_object")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      "font-weight": "bold",
                                                      "font-size": "14px",
                                                      width: "100px",
                                                    },
                                                    attrs: {
                                                      content:
                                                        attr.property.label,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        attr.property.label
                                                      ) + ":"
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "input-value",
                                                  },
                                                  [
                                                    attr.property.type ===
                                                    "json"
                                                      ? _c(
                                                          "div",
                                                          [
                                                            _c(
                                                              "button",
                                                              {
                                                                staticClass:
                                                                  "classic-button visitor-attr",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      _vm.JSONModal = true
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                            JSON PREVIEW\n                                        "
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _vm.JSONModal
                                                              ? _c(
                                                                  "Modal2",
                                                                  {
                                                                    attrs: {
                                                                      title:
                                                                        attr
                                                                          .property
                                                                          .label,
                                                                      "show-footer": false,
                                                                    },
                                                                    on: {
                                                                      cancel:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          _vm.JSONModal = false
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "prism-editor",
                                                                      {
                                                                        staticClass:
                                                                          "my-editor",
                                                                        attrs: {
                                                                          value:
                                                                            _vm.jsonFormat(
                                                                              attr.value ||
                                                                                "N/A"
                                                                            ),
                                                                          "line-numbers": false,
                                                                          highlight:
                                                                            _vm.highlighter,
                                                                          readonly:
                                                                            "",
                                                                        },
                                                                      }
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            display:
                                                                              "flex",
                                                                            "justify-content":
                                                                              "space-between",
                                                                          },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "SupsisButton",
                                                                          {
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.copyTextToClipboard(
                                                                                    attr.value ||
                                                                                      "N/A"
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                                                    COPY JSON\n                                                "
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "SupsisButton",
                                                                          {
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  _vm.JSONModal = false
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              " CANCEL "
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm._e(),
                                                          ],
                                                          1
                                                        )
                                                      : _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "w-full",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                        " +
                                                                _vm._s(
                                                                  attr.value ||
                                                                    "N/A"
                                                                ) +
                                                                "\n                                    "
                                                            ),
                                                          ]
                                                        ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "flex centered",
                                                  },
                                                  [
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "copyButton",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.copyTextToClipboard(
                                                              attr.value ||
                                                                "N/A"
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("a-icon", {
                                                          attrs: {
                                                            type: "copy",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e()
                                      }
                                    ),
                                  ],
                                  2
                                ),
                              ]),
                              _vm._v(" "),
                              (
                                _vm.selectedHistory.conversation.visitor
                                  .metaReferrals || []
                              ).length > 0
                                ? _c("VisitorMetaReferralsCard", {
                                    attrs: {
                                      metaReferrals:
                                        _vm.selectedHistory.conversation.visitor
                                          .metaReferrals,
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("VisitorCalendarCard", {
                                attrs: {
                                  visitorId:
                                    _vm.selectedHistory.conversation.visitor
                                      ._id,
                                },
                              }),
                              _vm._v(" "),
                              _c("div", { attrs: { id: "chatCard" } }, [
                                _c("div", { staticClass: "headtitle" }, [
                                  _c("span", { staticClass: "text" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "userInfoWidget.affiliatedRepresentatives"
                                        )
                                      ) + " "
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "align-items": "center",
                                    },
                                  },
                                  _vm._l(
                                    _vm.selectedHistory.conversation.users
                                      .length > 0
                                      ? _vm.selectedHistory.conversation.users.slice(
                                          0,
                                          3
                                        )
                                      : [
                                          _vm.selectedHistory.conversation
                                            .connectedUser,
                                        ],
                                    function (user, i) {
                                      return _c(
                                        "a-tag",
                                        { key: i, attrs: { color: "orange" } },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(_vm.getUserHelper(user)) +
                                              "\n                            "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { attrs: { id: "chatCard" } },
                                [
                                  _c("div", { staticClass: "headtitle" }, [
                                    _c("span", { staticClass: "text" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "userInfoWidget.preferredAgents"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _vm.selectedHistory.conversation.visitor
                                    ? _c("PreferredAgents", {
                                        attrs: {
                                          visitorId:
                                            _vm.selectedHistory.conversation
                                              .visitor._id,
                                          readOnly: true,
                                        },
                                        model: {
                                          value:
                                            _vm.selectedHistory.conversation
                                              .visitor.preferredAgents,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.selectedHistory.conversation
                                                .visitor,
                                              "preferredAgents",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "selectedHistory.conversation.visitor.preferredAgents",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { attrs: { id: "chatCard" } }, [
                                _c("div", { staticClass: "headtitle" }, [
                                  _c("span", { staticClass: "text" }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("userInfoWidget.labels"))
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  [
                                    _c("TagDialog", {
                                      attrs: { "hide-add": true },
                                      model: {
                                        value: _vm.tags,
                                        callback: function ($$v) {
                                          _vm.tags = $$v
                                        },
                                        expression: "tags",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { attrs: { id: "chatCard" } }, [
                                _c("div", { staticClass: "headtitle" }, [
                                  _c("span", { staticClass: "text" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("userInfoWidget.agentNotes")
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "ml-4" }, [
                                    !_vm.isNewNot
                                      ? _c(
                                          "button",
                                          {
                                            staticClass: "classic-button",
                                            on: {
                                              click: function ($event) {
                                                _vm.isNewNot = true
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "userInfoWidget.newNote"
                                                  )
                                                ) +
                                                "\n                                "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _vm.isNewNot ||
                                !_vm.infoObj ||
                                !_vm.infoObj.noteSender
                                  ? _c(
                                      "div",
                                      { staticClass: "rep-note-element mt-2" },
                                      [
                                        _c("a-textarea", {
                                          staticClass: "disableShortcut",
                                          model: {
                                            value: _vm.infoObj.info,
                                            callback: function ($$v) {
                                              _vm.$set(_vm.infoObj, "info", $$v)
                                            },
                                            expression: "infoObj.info",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "rep-note-actions mt-1",
                                          },
                                          [
                                            _c(
                                              "a-button-group",
                                              { attrs: { size: "small" } },
                                              [
                                                _vm.infoObj &&
                                                _vm.infoObj.noteSender
                                                  ? _c("a-button", {
                                                      staticClass:
                                                        "classic-button mr-1",
                                                      attrs: {
                                                        icon: "close",
                                                        type: "danger",
                                                      },
                                                      on: {
                                                        click: _vm.notSaveInfo,
                                                      },
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c("a-button", {
                                                  staticClass: "classic-button",
                                                  staticStyle: {
                                                    color: "rgb(38, 233, 38)",
                                                  },
                                                  attrs: {
                                                    icon: "check",
                                                    type: "primary",
                                                  },
                                                  on: { click: _vm.saveInfo },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.infoObj && _vm.infoObj.noteSender
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "old-note",
                                        on: {
                                          click: function ($event) {
                                            _vm.oldNoteIsOpen =
                                              !_vm.oldNoteIsOpen
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "classic-button open-note",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "material-icons icon",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.oldNoteIsOpen
                                                      ? "remove"
                                                      : "add"
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "information" },
                                          [
                                            _c("b", [_vm._v("1")]),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "userInfoWidget.available"
                                                  )
                                                )
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.oldNoteIsOpen &&
                                _vm.infoObj &&
                                _vm.infoObj.noteSender
                                  ? _c(
                                      "div",
                                      { staticClass: "old-note-desc" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "top-header" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "agent-name" },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.infoObj.noteSender)
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "agent-note" },
                                          [_vm._v(_vm._s(_vm.infoObj.info))]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              _c("div", { attrs: { id: "chatCard" } }, [
                                _c("div", { staticClass: "headtitle" }, [
                                  _c("span", { staticClass: "text" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "userInfoWidget.systemInformation"
                                        )
                                      )
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "details-chat-card" },
                                  [
                                    _c("div", { staticClass: "user-detail" }, [
                                      _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "tippy",
                                              rawName: "v-tippy",
                                              value: {
                                                followCursor: true,
                                                placement: "bottom-end",
                                              },
                                              expression:
                                                "{\n                                        followCursor: true,\n                                        placement: 'bottom-end',\n                                    }",
                                            },
                                          ],
                                          staticClass: "icon material-icons",
                                          attrs: {
                                            content: _vm.$t(
                                              "userInfoWidget.speechID"
                                            ),
                                          },
                                        },
                                        [_vm._v("badge")]
                                      ),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.selectedHistory.conversation._id
                                          )
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "user-detail" }, [
                                      _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "tippy",
                                              rawName: "v-tippy",
                                              value: {
                                                followCursor: true,
                                                placement: "bottom-end",
                                              },
                                              expression:
                                                "{\n                                        followCursor: true,\n                                        placement: 'bottom-end',\n                                    }",
                                            },
                                          ],
                                          staticClass: "icon material-icons",
                                          attrs: {
                                            content: _vm.$t(
                                              "userInfoWidget.customerVersion"
                                            ),
                                          },
                                        },
                                        [_vm._v("info")]
                                      ),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              (
                                                _vm.selectedHistory.conversation
                                                  .visitor.version || {
                                                  version: -1,
                                                  versionStr: "N/A",
                                                  buildNumber: -1,
                                                  commitHash: "",
                                                }
                                              ).versionStr
                                            ) +
                                            "\n                                "
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _vm.selectedHistory.conversation.ref !==
                                    "whatsapp"
                                      ? _c(
                                          "div",
                                          { staticClass: "user-detail" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "tippy",
                                                    rawName: "v-tippy",
                                                    value: {
                                                      followCursor: true,
                                                      placement: "bottom-end",
                                                    },
                                                    expression:
                                                      "{ followCursor: true, placement: 'bottom-end' }",
                                                  },
                                                ],
                                                staticClass:
                                                  "icon material-icons",
                                                attrs: {
                                                  content: _vm.$t(
                                                    "userInfoWidget.IPAddress"
                                                  ),
                                                },
                                              },
                                              [_vm._v("computer")]
                                            ),
                                            _vm._v(" "),
                                            !(
                                              !!_vm.selectedHistory.conversation
                                                .whatsappNumber ||
                                              !!_vm.selectedHistory.conversation
                                                .instagramUserId
                                            )
                                              ? _c("span", [
                                                  _vm._v(
                                                    "\n                                    " +
                                                      _vm._s(
                                                        _vm.selectedHistory
                                                          .conversation
                                                          .ipAddress
                                                      ) +
                                                      "\n                                "
                                                  ),
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.selectedHistory.conversation
                                              .ref === "instagram"
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      width: "30px",
                                                      height: "30px",
                                                    },
                                                  },
                                                  [
                                                    _c("InstagramIcon", {
                                                      attrs: {
                                                        width: 30,
                                                        height: 30,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.selectedHistory.conversation.ref ===
                                    "whatsapp"
                                      ? _c(
                                          "div",
                                          { staticClass: "user-detail" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "tippy",
                                                    rawName: "v-tippy",
                                                    value: {
                                                      followCursor: true,
                                                      placement: "bottom-end",
                                                    },
                                                    expression:
                                                      "{ followCursor: true, placement: 'bottom-end' }",
                                                  },
                                                ],
                                                attrs: { content: "Whatsapp" },
                                              },
                                              [
                                                _c(
                                                  "md-icon",
                                                  {
                                                    staticStyle: {
                                                      color: "#06e576",
                                                      "font-size": "11px",
                                                    },
                                                  },
                                                  [_vm._v(" whatsapp ")]
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "p",
                                              {
                                                staticStyle: {
                                                  "margin-left": "7px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.selectedHistory
                                                      .conversation
                                                      .whatsappNumber
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.getChannelName()
                                      ? _c(
                                          "div",
                                          { staticClass: "user-detail" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "tippy",
                                                    rawName: "v-tippy",
                                                    value: {
                                                      followCursor: true,
                                                      placement: "bottom-end",
                                                    },
                                                    expression:
                                                      "{ followCursor: true, placement: 'bottom-end' }",
                                                  },
                                                ],
                                                staticClass:
                                                  "icon material-icons",
                                                attrs: {
                                                  content: _vm.$t(
                                                    "whatsappChannel.channelName"
                                                  ),
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "hub\n                                "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(_vm.getChannelName()) +
                                                  "\n                                "
                                              ),
                                            ]),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.selectedHistory.conversation.ref !==
                                    "whatsapp"
                                      ? _c(
                                          "div",
                                          { staticClass: "user-detail" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "tippy",
                                                    rawName: "v-tippy",
                                                    value: {
                                                      followCursor: true,
                                                      placement: "bottom-end",
                                                    },
                                                    expression:
                                                      "{\n                                        followCursor: true,\n                                        placement: 'bottom-end',\n                                    }",
                                                  },
                                                ],
                                                staticClass:
                                                  "icon material-icons",
                                                attrs: {
                                                  content: _vm.$t(
                                                    "userInfoWidget.pageVisited"
                                                  ),
                                                },
                                              },
                                              [_vm._v("public")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "white-space": "nowrap",
                                                  overflow: "hidden",
                                                  "text-overflow": "ellipsis",
                                                },
                                              },
                                              [
                                                _vm.selectedHistory.conversation
                                                  .visitingPage
                                                  ? _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "info-label",
                                                        attrs: {
                                                          href: _vm
                                                            .selectedHistory
                                                            .conversation
                                                            .visitingPage
                                                            ? _vm
                                                                .selectedHistory
                                                                .conversation
                                                                .visitingPage
                                                            : "#",
                                                          target: "_blank",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.selectedHistory
                                                              .conversation
                                                              .visitingPage
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _c("span", [_vm._v("N/A")]),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "user-detail" }, [
                                      _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "tippy",
                                              rawName: "v-tippy",
                                              value: {
                                                followCursor: true,
                                                placement: "bottom-end",
                                              },
                                              expression:
                                                "{\n                                        followCursor: true,\n                                        placement: 'bottom-end',\n                                    }",
                                            },
                                          ],
                                          staticClass: "icon material-icons",
                                          attrs: {
                                            content: _vm.$t(
                                              "userInfoWidget.countryAndLanguage"
                                            ),
                                          },
                                        },
                                        [_vm._v("map")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "d-flex",
                                          staticStyle: {
                                            "align-items": "center",
                                          },
                                        },
                                        [
                                          _vm.getCountryCode(
                                            _vm.$_.get(
                                              _vm.selectedHistory,
                                              "conversation.geoLocation.country"
                                            ) ||
                                              _vm.selectedHistory.conversation
                                                .languageCode
                                          )
                                            ? _c("country-flag", {
                                                directives: [
                                                  {
                                                    name: "tippy",
                                                    rawName: "v-tippy",
                                                    value: {
                                                      followCursor: true,
                                                      placement: "bottom-end",
                                                      theme: _vm.isDarkMode
                                                        ? "light-border"
                                                        : "google",
                                                    },
                                                    expression:
                                                      "{\n                                            followCursor: true,\n                                            placement: 'bottom-end',\n                                            theme: isDarkMode ? 'light-border' : 'google',\n                                        }",
                                                  },
                                                ],
                                                staticStyle: {
                                                  "margin-top": "-8px",
                                                },
                                                attrs: {
                                                  content: _vm.getCountryName(
                                                    _vm.$_.get(
                                                      _vm.selectedHistory,
                                                      "conversation.geoLocation.country"
                                                    ) ||
                                                      _vm.selectedHistory
                                                        .conversation
                                                        .languageCode
                                                  ),
                                                  country: _vm.getCountryCode(
                                                    _vm.$_.get(
                                                      _vm.selectedHistory,
                                                      "conversation.geoLocation.country"
                                                    ) ||
                                                      _vm.selectedHistory
                                                        .conversation
                                                        .languageCode
                                                  ),
                                                  size: "normal",
                                                },
                                              })
                                            : _c(
                                                "span",
                                                {
                                                  directives: [
                                                    {
                                                      name: "tippy",
                                                      rawName: "v-tippy",
                                                      value: {
                                                        followCursor: true,
                                                        placement: "bottom-end",
                                                        theme: _vm.isDarkMode
                                                          ? "light-border"
                                                          : "google",
                                                      },
                                                      expression:
                                                        "{\n                                            followCursor: true,\n                                            placement: 'bottom-end',\n                                            theme: isDarkMode ? 'light-border' : 'google',\n                                        }",
                                                    },
                                                  ],
                                                  attrs: {
                                                    content: _vm.getCountryName(
                                                      _vm.$_.get(
                                                        _vm.selectedHistory,
                                                        "conversation.geoLocation.country"
                                                      ) ||
                                                        _vm.selectedHistory
                                                          .conversation
                                                          .languageCode
                                                    ),
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(
                                                        _vm.selectedHistory
                                                          .conversation
                                                          .geoLocation
                                                          ? _vm.selectedHistory
                                                              .conversation
                                                              .geoLocation
                                                              .country
                                                          : "N/A"
                                                      ) +
                                                      "\n                                    "
                                                  ),
                                                ]
                                              ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "margin-left": "5px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm.selectedHistory.conversation.languageCode.toUpperCase()
                                                  ) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "user-detail" }, [
                                      !(
                                        _vm.selectedHistory.conversation
                                          .whatsappNumber ||
                                        _vm.selectedHistory.conversation
                                          .instagramUserId
                                      )
                                        ? _c(
                                            "span",
                                            [
                                              _vm.selectedHistory.conversation
                                                .visitor.os &&
                                              _vm.selectedHistory.conversation
                                                .visitor.browser
                                                ? _c("VisitorBrowserAndOs", {
                                                    attrs: {
                                                      visitor:
                                                        _vm.selectedHistory
                                                          .conversation.visitor,
                                                    },
                                                  })
                                                : _c("p", [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(
                                                          _vm.getUserDetailedLoginInfo(
                                                            _vm.selectedHistory
                                                              .conversation
                                                              .userAgent
                                                          )
                                                        ) +
                                                        "\n                                    "
                                                    ),
                                                  ]),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]),
                                  ]
                                ),
                              ]),
                            ],
                            1
                          )
                        : _c(
                            "div",
                            {
                              staticClass: "text-center information-list2",
                              staticStyle: { padding: "unset" },
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("message.noMessageInChat")) +
                                  "\n                "
                              ),
                            ]
                          ),
                    ]
                  ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isModalShow
        ? _c(
            "Modal2",
            {
              attrs: {
                id: "visitor-message",
                title: _vm.$t("message.visitorFeedback"),
                "show-footer": false,
              },
              on: { cancel: _vm.hideModal },
            },
            [
              _c(
                "p",
                {
                  staticClass: "my-4",
                  staticStyle: { "word-wrap": "break-word" },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.selectedHistory.conversation.description) +
                      "\n        "
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isAdmin ? _c("ChatBar", { attrs: { visible: false } }) : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }